<div class="xcm-content">
    <xcm-header-nav></xcm-header-nav>
    <ng-progress ngProgressRouter/>
    <div class="container-fluid">
    <xcm-alert [timeout]="10000"></xcm-alert>
    <router-outlet></router-outlet>
    </div>
</div>
<xcm-footer></xcm-footer>



